import {DataTableColumn} from "mantine-datatable";
import {UsageEvent} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {BillableBadge} from "../profile/Badges.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";

export const useTableColumns = () => {

    const columns: DataTableColumn<UsageEvent>[] = [
        {
            accessor: 'eventId',
            title: I18n.get('Event'),
            width: '1fr',
            render: (item: UsageEvent) => item.eventId,
        },
        {
            accessor: 'meterCode',
            title: I18n.get('Meter'),
            width: '1fr',
            render: (item: UsageEvent) => item.meterCode ?? '-',
        },
        {
            accessor: 'customerId',
            title: I18n.get('Customer'),
            width: '1fr',
            render: (item: UsageEvent) => item.customerId ?? '-',
        },
        {
            accessor: 'accountId',
            title: I18n.get('Account'),
            width: '1fr',
            render: (item: UsageEvent) => item.accountId ?? '-',
        },
        {
            accessor: 'quantity',
            title: I18n.get('Quantity'),
            width: '1fr',
            render: (item: UsageEvent) => typeof item.quantity === 'number' ? String(item.quantity) : '-',
        },
        {
            accessor: 'occurredAt',
            title: I18n.get('Occurred'),
            width: '1fr',
            render: (item: UsageEvent) => item.occurredAt ? formatTimestamp(item.occurredAt as string) : '-',
        },
        {
            accessor: 'receivedAt',
            title: I18n.get('Ingested'),
            width: '1fr',
            render: (item: UsageEvent) => item.receivedAt ? formatTimestamp(item.receivedAt as string) : '-',
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: UsageEvent) => <BillableBadge record={item}/>,
        },
    ];

    return {
        columns,
    }
}
